import axios from "axios";
import { OrganizationURL } from "../../../config/UrlEndPoint";

export const URL = `${OrganizationURL}library`;

//  * FIND LIBRARY FOLDER
export function findlibraryFolder(queryParams) {
  return axios.post(`${URL}/find_folder`, queryParams);
}

//  * FIND LIBRARY FILE
export function findlibraryFile(queryParams) {
  return axios.post(`${URL}/find_file`, queryParams);
}

// * UPLOAD FILE
export function createLibraryFile(payload) {
  return axios.post(`${URL}/create_file`, payload);
}
